import Mynav from './common/mynav'
import Mypicker from './common/mypicker'
import Myareapicker from './common/myareapicker'
import Mydatepicker from './common/mydatepicker'
import MyFooter from './common/myfooter'
import MyVfcCode from './common/myvfccode'
import MyAddr from './ordersub/myaddr'

export default {
    install: function (Vue) {
        Vue.use(Mynav)
        Vue.use(Mypicker)
        Vue.use(Myareapicker)
        Vue.use(Mydatepicker)
        Vue.use(MyFooter)
        Vue.use(MyVfcCode)
        Vue.use(MyAddr)
    }
}
